// extracted by mini-css-extract-plugin
export default {"successVariant":"App_successVariant__EUZ+F","errorVariant":"App_errorVariant__MSMGU","infoVariant":"App_infoVariant__yVfvT"};